import { render, staticRenderFns } from "./CakeList.vue?vue&type=template&id=884bbc7c&scoped=true&"
import script from "./CakeList.vue?vue&type=script&lang=js&"
export * from "./CakeList.vue?vue&type=script&lang=js&"
import style0 from "./CakeList.vue?vue&type=style&index=0&id=884bbc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884bbc7c",
  null
  
)

export default component.exports